import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { NTH_USER_EMOJI_TITLE_DISCOVERED } from '../../constants/onboarding-state/onboarding-constants.ts';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql.ts';

export const preloadNthUserEmojiTitleDiscovered = () => {
	return query({
		// Will be addressed in: https://hello.jira.atlassian.cloud/browse/ACTIVATION-1475
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [NTH_USER_EMOJI_TITLE_DISCOVERED.EMOJI_TITLE_DISCOVERED],
		},
	});
};
